import styled from '@emotion/styled';
import { ITheme } from '../../../themer';
import themed from '../../../themer/themed';

export const DropdownItemHint = styled.div<{}, ITheme>`
	color: ${themed(({ dropdownList }) => dropdownList.option.hint.color)};
	margin-left: 6px;
`;
